import { get, put, post, axios } from './baseAxios';
import { API_TOUR_BG_SOUND, API_TOUR_SOUND } from '../utils/urls';

export const getTourSound = (id) => get(`${API_TOUR_SOUND}/${id}`);

export const getTourGuides = (request) => get(API_TOUR_SOUND, request);

export const getTourBgSounds = (request) => get(API_TOUR_BG_SOUND, request);

export const updateTourSound = (id, request) => put(`${API_TOUR_SOUND}/${id}`, request);

export const createTourSound = (request) => post(API_TOUR_SOUND, request);

export const deleteTourSound = (id) => axios.delete(`${API_TOUR_SOUND}/${id}`);

export const updateSubtitle = (id, request) => put(`${API_TOUR_SOUND}/${id}/subtitle`, request);
